<script>
import Views from "./Views.vue";
import Tabs from "./Tabs.vue";
import List from "./List.vue";
import GroupList from "./partials/GroupList.vue";
import TypeList from "./partials/TypeList.vue";
import QuestionList from "./partials/QuestionList.vue";
import FilteredList from "./FilteredList.vue";
import MembersTab from "./partials/MembersTab.vue";
import AlertsTab from "./partials/AlertsTab.vue";
import NewsTab from "./partials/NewsTab.vue";
import MemberPracticesTab from "./partials/MemberPracticesTab.vue";
import PCNEventsTab from "./partials/PCNEventsTab.vue";
import FooterTab from "./partials/FooterTab.vue";
import QuickLinksTab from "./partials/QuickLinksTab.vue";
import BannerConfigTabs from "./partials/BannerConfigTabs.vue";
import BannersTab from "./partials/BannersTab.vue";
import JobVacanciesTab from "./partials/JobVacanciesTab.vue";
import ClinicsAndServicesTab from "./partials/ClinicsAndServicesTab.vue";
import ContactUsOptionsTab from "./partials/ContactUsOptionsTab.vue";
import GroupsTab from "./partials/GroupsTab.vue";
import ClinicServicesGroupsTab from "./partials/ClinicServicesGroupsTab.vue";
import TypesTab from "./partials/TypesTab.vue";
import OptionsTab from "./partials/OptionsTab.vue";
import HelpusTab from "./partials/HelpusTab.vue";
import QuestionsTab from "./partials/QuestionsTab.vue";
import FAQTab from "./partials/FAQTab.vue";
import LocationsTab from "./partials/LocationsTab.vue";
import PatientAssistTab from "./partials/PatientAssistTab.vue";
import PatientVoiceTab from "./partials/PatientVoiceTab.vue";
import PcnServicesTab from "./partials/PcnServicesTab.vue";
import PatientGroupTab from "./partials/PatientGroupTab.vue";
import InfoPagesTab from "./partials/InfoPagesTab.vue";
import DescriptionTab from "./partials/DescriptionTab.vue";
import PresOptionsTab from "./partials/PresOptionsTab.vue";
import OnlineServicesTab from "./partials/OnlineServicesTab.vue";
import GeneralCategoryTab from "./partials/GeneralCategoryTab.vue";
import HealthierTogetherTab from "./partials/HealthierTogetherTab.vue";
import PracticeClosureTab from "./partials/PracticeClosureTab.vue";
import RegularHoursTab from "./partials/RegularHoursTab.vue";
import RegularHoursFilteredList from "./partials/RegularHoursFilteredList.vue";
import Form from "./Form.vue";
import Topbar from "./topbar/index.vue";

export default {
  name: "Views",
  props: {
    view: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
  },
  components: {
    Views,
    Tabs,
    List,
    Topbar,
    Form,
    FilteredList,
    RegularHoursFilteredList,
    MembersTab,
    FooterTab,
    QuickLinksTab,
    BannerConfigTabs,
    GroupList,
    BannersTab,
    GroupsTab,
    DescriptionTab,
    AlertsTab,
    NewsTab,
    InfoPagesTab,
    LocationsTab,
    PracticeClosureTab,
    RegularHoursTab,
    OnlineServicesTab,
    GeneralCategoryTab,
    HealthierTogetherTab,
    JobVacanciesTab,
    PatientGroupTab,
    PcnServicesTab,
    MemberPracticesTab,
    PCNEventsTab,
    ClinicsAndServicesTab,
    TypesTab,
    TypeList,
    QuestionsTab,
    QuestionList,
    ClinicServicesGroupsTab,
    ContactUsOptionsTab,
    FAQTab,
    OptionsTab,
    HelpusTab,
    PatientAssistTab,
    PatientVoiceTab,
    PresOptionsTab,
  },
};
</script>
<template>
  <Topbar
    v-if="view.type == 'topbar'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :attr="view"
    :topbarControls="topbarControls"
    :setTopbarControls="setTopbarControls"
  />
  <GroupList
    v-else-if="view.type == 'groupList'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <TypeList
    v-else-if="view.type == 'typeList'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <QuestionList
    v-else-if="view.type == 'questionList'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <List
    v-else-if="view.type == 'list'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <RegularHoursFilteredList
    v-else-if="view.type == 'regularHoursFilteredList'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <OnlineServicesTab
    v-else-if="view.type == 'onlineServicesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <GeneralCategoryTab
    v-else-if="view.type == 'generalCategoryTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />

  <HealthierTogetherTab
    v-else-if="view.type == 'healthierTogetherTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <DescriptionTab
    v-else-if="view.type == 'descriptionTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PresOptionsTab
    v-else-if="view.type == 'presOptionsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <LocationsTab
    v-else-if="view.type == 'locationsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PatientAssistTab
    v-else-if="view.type == 'patientAssistTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PatientVoiceTab
    v-else-if="view.type == 'patientVoiceTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PcnServicesTab
    v-else-if="view.type == 'pcnServicesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PatientGroupTab
    v-else-if="view.type == 'patientGroupTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <GroupsTab
    v-else-if="view.type == 'groupsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <ClinicServicesGroupsTab
    v-else-if="view.type == 'clinicServicesGroupsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <TypesTab
    v-else-if="view.type == 'typesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <OptionsTab
    v-else-if="view.type == 'optionsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <HelpusTab
    v-else-if="view.type == 'helpusTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <QuestionsTab
    v-else-if="view.type == 'questionsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <FAQTab
    v-else-if="view.type == 'faqTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <InfoPagesTab
    v-else-if="view.type == 'infoPagesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <NewsTab
    v-else-if="view.type == 'newsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <MemberPracticesTab
    v-else-if="view.type == 'memberPracticesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PCNEventsTab
    v-else-if="view.type == 'pcnEventsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <JobVacanciesTab
    v-else-if="view.type == 'jobVacanciesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <ClinicsAndServicesTab
    v-else-if="view.type == 'clinicsAndServicesTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <ContactUsOptionsTab
    v-else-if="view.type == 'contactUsOptionsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <AlertsTab
    v-else-if="view.type == 'alertsTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <PracticeClosureTab
    v-else-if="view.type == 'practiceClosureTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <RegularHoursTab
    v-else-if="view.type == 'regularHoursTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <MembersTab
    v-else-if="view.type == 'membersTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <FooterTab
    v-else-if="view.type == 'footerTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <QuickLinksTab
    v-else-if="view.type == 'quickLinksTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <BannerConfigTabs
    v-else-if="view.type == 'bannerConfigTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <BannersTab
    v-else-if="view.type == 'bannersTab'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <FilteredList
    v-else-if="view.type == 'filteredList'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :item="view"
    :items="view.children"
    :setTopbarControls="setTopbarControls"
    :topbarControls="topbarControls"
  />
  <Form
    v-else-if="view.type == 'form'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :form="view.form"
    :variant="view.variant"
    :data="selectedItem"
    :topbarControls="topbarControls"
  />
  <Tabs
    v-else-if="view.type == 'tabs'"
    :style="view.style"
    :class="`col-${view.size} ${view.class}`"
    :tabs="view.children"
    :topbarControls="topbarControls"
    :setTopbarControls="setTopbarControls"
  />
  <div v-else-if="view.children">
    <div v-for="(child, index) in view.children" :key="index">
      <Views :view="child" />
    </div>
  </div>
</template>
